export default __webpack_public_path__ + "static/media/icon-banking-and-coverage.c19127eb.svg";